module.exports = __webpack_public_path__ + "img/danye8.26c25494.jpg";